import { useState } from 'react';
import { requestUserDataExport, requestMediaExport } from '../api/getDataExport';

const BAD_REQUEST = 400;
const GENERIC_ERROR = 'There was an error exporting your user data.';
const GENERIC_MEDIA_ERROR = 'There was an error exporting your media.';
const MEDIA_TOO_LARGE_ERROR = 'Your media is too large to export.';

export default function useDataExport() {
    const [isLoading, setIsLoading] = useState(false);
    const [isMediaLoading, setIsMediaLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isMediaSuccess, setIsMediaSuccess] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [mediaErrorMessage, setMediaErrorMessage] = useState<string | null>(null);

    const exportUserData = async () => {
        setIsLoading(true);
        setIsSuccess(false);
        setErrorMessage(null);
        try {
            const response = await requestUserDataExport();

            if (!response || response.status) {
                setErrorMessage(GENERIC_ERROR);
            } else {
                setIsSuccess(true);
            }
        } catch (error) {
            console.error('Error exporting data:', error);
            setErrorMessage(GENERIC_ERROR);
        }
        setIsLoading(false);
    };

    const exportMedia = async () => {
        setIsMediaLoading(true);
        setIsMediaSuccess(false);
        setMediaErrorMessage(null);
        try {
            const response = await requestMediaExport();

            if (!response) {
                setMediaErrorMessage(GENERIC_MEDIA_ERROR);
            } else if (response.status === BAD_REQUEST) {
                setMediaErrorMessage(MEDIA_TOO_LARGE_ERROR);
            } else if (response.status) {
                setMediaErrorMessage(GENERIC_MEDIA_ERROR);
            } else {
                setIsMediaSuccess(true);
            }
        } catch (error) {
            console.error('Error exporting media:', error);
            setMediaErrorMessage(GENERIC_MEDIA_ERROR);
        }
        setIsMediaLoading(false);
    };

    return {
        exportUserData,
        exportMedia,
        isLoading,
        isMediaLoading,
        isSuccess,
        isMediaSuccess,
        errorMessage,
        mediaErrorMessage
    };
}
